
class DataLayerHelper {
    private getDataLayer = (): object[] => {
        (window as any).dataLayer = (window as any).dataLayer || [];
        return (window as any).dataLayer;
    }

    sendEvent(event: object) {
        this.getDataLayer().push(event);
        
        if (import.meta.env.DEV) {
            console.log('Data Layer', this.getDataLayer())
        }
    }
}

const DataLayer = new DataLayerHelper();

export default DataLayer;